import { FilterSpendingDemand } from "../types/spendingDemand.types";


export const getQueryFilterIntervalValue = (min : any, max : any) => {
    if(min === undefined && max === undefined){
        return null
    }
    let result = "";

    let resultMin = "";
    let resultMax = "";
    let separator = ""
    if (min !== undefined){
        resultMin += ">=" + min;
    }
    if (max !== undefined){
        resultMax += "<=" + max;
    }

    
    if(resultMin !== "" && resultMax !== ""){
        separator = ','
    }
    result = resultMin +separator+ resultMax
    return result;

}


export interface ResultQueryFilter {
    queryString: string;
    queryArray: {key: string, value: string | null}[]

}

const buildQuerySearchValue = (filter: FilterSpendingDemand): string | null => {
    const readableIdTerm = filter.readableId?.trim();
    const boxIdTerm = filter.boxId?.trim();
    const searchTerms = [readableIdTerm, boxIdTerm].filter((term): term is string => !!term);

    if (searchTerms.length === 0) {
        return null;
    }

    // Join both inputs to keep one text-search param for backend SEARCH().
    return searchTerms.join(" ");
}

export const FilterpendingDemandConverterToQuery = (filter : FilterSpendingDemand | null | undefined, startWith?: "?" | "&" ) : ResultQueryFilter=> {

    if (filter === null || filter === undefined){
        return {
            queryString: "",
            queryArray : []
        }
    }

    // Si whereQuery est fourni directement, l'utiliser
    if (filter.whereQuery) {
        return {
            queryString: "",
            queryArray: [
                {
                    key: 'whereQuery',
                    value: filter.whereQuery
                }
            ]
        }
    }

    // Construire la whereQuery à partir des filtres individuels
    const whereConditions: string[] = []

    // Filtre par statut (chaînes de caractères - utiliser =)
    if (filter.status && filter.status.length > 0) {
        if (filter.status.length === 1) {
            whereConditions.push(`spending_demand_status=${filter.status[0]}`)
        } else {
            whereConditions.push(`spending_demand_status<in>[${filter.status.join(',')}]`)
        }
    }

    // Filtre par type (chaînes de caractères - utiliser =)
    if (filter.type && filter.type.length > 0) {
        if (filter.type.length === 1) {
            whereConditions.push(`spending_demand_type=${filter.type[0]}`)
        } else {
            whereConditions.push(`spending_demand_type<in>[${filter.type.join(',')}]`)
        }
    }

    // Filtre par montant HT
    if (filter.amount?.min !== undefined || filter.amount?.max !== undefined) {
        if (filter.amount.min !== undefined && filter.amount.max !== undefined) {
            whereConditions.push(`spending_demand_amount>>=${filter.amount.min}|spending_demand_amount<<=${filter.amount.max}`)
        } else if (filter.amount.min !== undefined) {
            whereConditions.push(`spending_demand_amount>>=${filter.amount.min}`)
        } else if (filter.amount.max !== undefined) {
            whereConditions.push(`spending_demand_amount<<=${filter.amount.max}`)
        }
    }

    // Filtre par montant TTC
    if (filter.amountTTC?.min !== undefined || filter.amountTTC?.max !== undefined) {
        if (filter.amountTTC.min !== undefined && filter.amountTTC.max !== undefined) {
            whereConditions.push(`spending_demand_amountTTC>>=${filter.amountTTC.min}|spending_demand_amountTTC<<=${filter.amountTTC.max}`)
        } else if (filter.amountTTC.min !== undefined) {
            whereConditions.push(`spending_demand_amountTTC>>=${filter.amountTTC.min}`)
        } else if (filter.amountTTC.max !== undefined) {
            whereConditions.push(`spending_demand_amountTTC<<=${filter.amountTTC.max}`)
        }
    }

    // Filtre par date (chaînes de caractères - utiliser >= et <=)
    if (filter.date?.min || filter.date?.max) {
        if (filter.date.min && filter.date.max) {
            whereConditions.push(`spending_demand_date>=${filter.date.min}|spending_demand_date<=${filter.date.max}`)
        } else if (filter.date.min) {
            whereConditions.push(`spending_demand_date>=${filter.date.min}`)
        } else if (filter.date.max) {
            whereConditions.push(`spending_demand_date<=${filter.date.max}`)
        }
    }

    // Filtre par date de mise à jour (chaînes de caractères - utiliser >= et <=)
    if (filter.updateDate?.min || filter.updateDate?.max) {
        if (filter.updateDate.min && filter.updateDate.max) {
            whereConditions.push(`spending_demand_update_date>=${filter.updateDate.min}|spending_demand_update_date<=${filter.updateDate.max}`)
        } else if (filter.updateDate.min) {
            whereConditions.push(`spending_demand_update_date>=${filter.updateDate.min}`)
        } else if (filter.updateDate.max) {
            whereConditions.push(`spending_demand_update_date<=${filter.updateDate.max}`)
        }
    }

    // Filtre par utilisateur (chaînes de caractères - utiliser =)
    if (filter.userId && filter.userId.length > 0) {
        if (filter.userId.length === 1) {
            whereConditions.push(`spending_demand_user=${filter.userId[0]}`)
        } else {
            whereConditions.push(`spending_demand_user<in>[${filter.userId.join(',')}]`)
        }
    }

    // Filtre par projet (chaînes de caractères - utiliser =)
    if (filter.projectId && filter.projectId.length > 0) {
        if (filter.projectId.length === 1) {
            whereConditions.push(`spending_demand_project=${filter.projectId[0]}`)
        } else {
            whereConditions.push(`spending_demand_project<in>[${filter.projectId.join(',')}]`)
        }
    }

    // Filtre par box association ID (chaînes de caractères - utiliser =)
    if (filter.boxAssociationId && filter.boxAssociationId.length > 0) {
        if (filter.boxAssociationId.length === 1) {
            whereConditions.push(`spending_demand_box_association_id=${filter.boxAssociationId[0]}`)
        } else {
            whereConditions.push(`spending_demand_box_association_id<in>[${filter.boxAssociationId.join(',')}]`)
        }
    }

    // Filtre par readable ID (recherche par préfixe)
    if (filter.readableId && filter.readableId.trim() !== '') {
        whereConditions.push(`spending_demand_readable_id<like>${filter.readableId.trim()}`)
    }

    // Construire la whereQuery finale
    const whereQuery = whereConditions.length > 0 ? whereConditions.join('|') : null

    // Paramètres traditionnels pour compatibilité
    const spendingDemandOrderBy = filter.orderBy || null
    const spendingDemandToProcessStatus = filter.toProcessStatus !== undefined ? (filter.toProcessStatus ? "true" : "false") : null
    const managerWaitingValidation = filter.managerWaitingValidation?.join(",") || null
    const querySearch = buildQuerySearchValue(filter)

    const resultArray = [
        {
            key: 'whereQuery',
            value: whereQuery
        },
        {
            key: 'orderBy',
            value: spendingDemandOrderBy
        },
        {
            key: 'toProcessStatus',
            value: spendingDemandToProcessStatus
        },
        {
            key: 'managerWaitingValidation',
            value: managerWaitingValidation
        },
        {
            key: 'querySearch',
            value: querySearch
        },
        {
            key: 'descSearch',
            value: filter.description?.trim() || null
        }
    ].filter(item => item.value !== null)

    return {
        queryString: "",
        queryArray: resultArray
    }
}